var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notFound"},[_c('h4',{staticClass:"text-dark font-weight-bolder"},[_vm._v("Page not found!")])])])}]

export { render, staticRenderFns }